<template>
  <article class="order-page">

    <!-- <child-page-header
    :titleText="titleText"
    :logoImg='logoImg'
    :showGoBack="showGoBack"
    ></child-page-header> -->

    <section class="order-container">

      <header>

        <div class="thumb-wrap">
          <img src="http://img18.3lian.com/d/file/201711/03/33658744127579fb2b7252146dd79a36.png" alt="">
        </div>

        <div class="text-description">
          <div>
            <h3>各大机场,提前抢购!</h3>
            <p class="gray-text">
              <span>{{submitInfo.linkMan}}</span>
              <span>{{submitInfo.phone}}</span>
              <span>{{submitInfo.bookDate}}</span>
              <!-- <span v-for="(value,key,index) in submitInfo" :key="index">{{value}}</span> -->
            </p>
            <p class="red-text"><i class="iconfont icon-renminbi"></i><span>500.00</span></p>
          </div>
          <span>x{{submitInfo.goodsAmount}}</span>
        </div>

      </header>



      <div class="show-price">
        <p>
          <span>商品金额</span>
          <span><i class="iconfont icon-renminbi"></i>888.00</span>
        </p>
        <p>
          <span>合计:</span>
          <span class="red-text"><i class="iconfont icon-renminbi"></i>888.00</span>
        </p>
      </div>

      <p class="gray-text">消费提醒:货款直接给商家,由商家承担全部售后服务</p>

    </section>

    <child-page-footer
    :btnText="footBtnText"
    :submitOrderBtn="submitOrderBtn"
    :goodsPrice="goodsPrice"
    ></child-page-footer>

  </article>

</template>

<script>

import Header from './child-components/Header'
import Footer from './child-components/Footer'

export default {
  name:"submit-order",
  data () {
    return {
      titleText:"中山城市候机楼",
      logoImg:false,
      showGoBack:true,

      //foot-parameter-------------------
      footBtnText:"提交订单",
      submitOrderBtn: true,
      goodsPrice: true,
      submitInfo:null,
    }
  },
  components:{
  		"child-page-header":Header,
      "child-page-footer":Footer,
  },
  methods:{
    getRouterData(){
      if (this.$route.params.submitInfo) {
      	this.submitInfo = this.$route.params.submitInfo;
      } else {
          alert("联系人资料缺失!请补全");
      		this.$router.go(-1);
      	}
    }
  },
  created() {
    this.getRouterData();
  },
}

</script>

<style lang="less">

  @import '.././style/variable';


  .order-container{
    flex: 1;
    .overfA();

    header,.leave-msg,.show-price{
      background-color: #fff;
      padding: 3%;
      .margin-B();
    }
    header{
      .border-B();
      .flex_wrap(space-between,center,initial,initial);
      .thumb-wrap{
        margin: 0 3%;
        .flex_items(20%,0,0,initial);
        img{
          width: 1.6rem;
          height: 1.6rem;
          padding: 5%;
          border: 1px solid #888;
        }
      }
      .text-description{
        flex: 1;
        .flex_wrap(space-between,center,initial,initial);
        &>span{
          margin-right: 3%
        }
        &>p{
          span{
            margin-right:5px;
          }
        }
      }
    }
    .leave-msg{
      .flex_wrap(initial,center,initial,initial);
      &>span,&>input{
        line-height: .8rem;
        padding-left: 3%;
      }
      &>input{
        flex: 1;
        border:none;
        font-size: .35rem;
        padding-top: 2px;
      }
    }
    .show-price{
      p{
        line-height: 1rem;
        padding: 0 3%;
      }
      &>p:first-child{
        .flex_wrap(space-between,center,initial,initial);
        border-bottom: 1px dashed #888;
      }
      &>p:last-child{
        text-align: right
      }
    }
    &>p:last-child{
      line-height: 1.2rem;
      text-align: center;
      margin-top: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/SubmitOrder.vue